/**
 * 浏览域错误码 → 文案映射(product-detail.md 错误态 / 社交动作失败码)。
 * 业务码来自 envelope.code(ServerError.code);非业务(网络等)归 RN_NETWORK。
 */
import { ServerError } from '@/api/client';

/** 商品详情整页错误文案(按 error.code)。 */
export function detailErrorMessage(err: unknown): string {
  const code = err instanceof ServerError ? err.code : 'RN_NETWORK';
  switch (code) {
    case '020001':
      return '商品不存在';
    case '020003':
      return '商品已下架';
    case 'RN_NETWORK':
      return '网络异常,请稍后重试';
    default:
      return '出错了';
  }
}

/** 社交动作(收藏/点赞/关注)失败 → Toast 文案。 */
export function socialErrorMessage(err: unknown, fallback: string): string {
  if (!(err instanceof ServerError)) return fallback;
  switch (err.code) {
    case '020801':
      return '收藏已达上限(200)';
    case '020802':
    case '100203':
      return '商品不存在或已下架';
    case '100101':
      return '不能关注自己';
    case '100103':
      return '卖家不存在或已注销';
    case '100201':
      return '不能给自己点赞';
    default:
      return err.message || fallback;
  }
}
